import { Moengage } from "./moengage";
import { Mixpanel } from "./mixpanel";
import configureStore from "../store/configureStore";

const store = configureStore()
const state = store.getState();
const analyticsVendors = [Mixpanel, Moengage];

export const trackEvent = (eventName, eventData) => {
  if (state.user && state.user.configs && (
    ("event_tracking" in state.user.configs && state.user.configs.event_tracking.mixpanel_is_enabled_dweb)
    ||
    ("eventTracking" in state.user.configs && state.user.configs.eventTracking.mixpanel_is_enabled_dweb)
  )
  ) {
    for (let vendor of analyticsVendors) {
      vendor.trackEvent(eventName, eventData);
    }
  }
};

export const loginEvent = (user) => {
  if (state.user && state.user.configs && (
    ("event_tracking" in state.user.configs && state.user.configs.event_tracking.mixpanel_is_enabled_dweb)
    ||
    ("eventTracking" in state.user.configs && state.user.configs.eventTracking.mixpanel_is_enabled_dweb)
  )
  ) {
    for (let vendor of analyticsVendors) {
      vendor.userLogin(user);
    }
  }
}

export const logoutEvent = () => {
  if (state.user && state.user.configs && (
    ("event_tracking" in state.user.configs && state.user.configs.event_tracking.mixpanel_is_enabled_dweb)
    ||
    ("eventTracking" in state.user.configs && state.user.configs.eventTracking.mixpanel_is_enabled_dweb)
  )
  ) {
    for (let vendor of analyticsVendors) {
      vendor.userLogout();
    }
  }
}